import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiTestTypesList, apiTestTypesView } from 'Services/UserService'

export const getData = createAsyncThunk('user/testTypes/getData', async datas => {
    const { data } = await apiTestTypesList(datas)
    return data
})

export const getView = createAsyncThunk('user/testTypes/getView', async id => {
    if (!id) return viewData
    const { data } = await apiTestTypesView(id)
    data.vector_group = data?.vector_group ?? []
    data.type_tests = data?.type_tests ?? []
    data.details = data?.details ?? {}
    return data
})

const viewData = {
    name: '',
    position: '',
    group: 'INDUCTORS & TRANSFORMERS',
    type_test: '',
    vector_group: [],
    type_tests: [],
    new_page: 1,
    format_no: '',
    reference_standards: [],
    details: {},
}

export const testTypesSlice = createSlice({
    name: 'user/testTypes',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            type_test: '',
            type_tests: '',
            status: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setTypeTest: (state, { payload }) => {
            state.table.page = 1
            state.table.type_test = payload
        },
        setTypeTests: (state, { payload }) => {
            state.table.page = 1
            state.table.type_tests = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
        setReset: (state, { payload }) => {
            state.table.page = 1
            state.table.type_test = ''
            state.table.type_tests = ''
            state.table.status = ''
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setTypeTest, setTypeTests, setStatus, setReset } = testTypesSlice.actions

export default testTypesSlice.reducer
